import styled, { css } from 'styled-components';

import { colors } from 'global/colors';

export const CanvasControllerBar = styled.div`
  position: relative;
  width: 100%;
  height: 35px;
  display: flex;
  flex-direction: row;
  background: ${({ theme }) => theme.freecode.headerBackground};
  justify-content: space-between;
`;

export const CanvasControllerContainer = styled.div`
  margin-top: 5px;
  margin-left: 5px;
  margin-right: 5px;
  height: 35px;
  display: flex;
  flex-direction: row;
  column-gap: 5px;
`;

export const IconButtonContainer = styled.button`
  border: 0;
  line-height: 0;
  height: 25px;
  width: 25px;
  ${({ theme }) => css`
    background: ${theme.freecode.buttonBackground};
    color: ${theme.freecode.buttonColor};
    &:hover {
      background: ${({ theme }) => theme.freecode.buttonBackgroundHover};
    }
    &:disabled {
      background: ${({ theme }) => theme.button.backgroundDisabled};
    }
  `}
`;

export const Icon = styled.i.attrs(({ icon }) => ({
  // icon is a required prop
  className: icon,
}))`
  font-size: 1rem;
`;

export const ProgressBarContainer = styled.div`
  cursor: pointer;
  background-color: ${colors.gray3};
  height: 2px;
  width: 100%;
  bottom: 35px;
  display: initial;
  position: absolute;
  &:hover {
    height: 10px;
    bottom: 33px;
  }
`;

export const ProgressBarFill = styled.div`
  left: 0px;
  height: 100%;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: row;
`;

export const ProgressBarLeft = styled.div.attrs(({ progressPercentage }) => ({
  style: { width: progressPercentage + '%' },
}))`
  background: ${colors.gray};
`;

export const ProgressBarMarker = styled.div.attrs(({ progressPercentage, isHovering }) => {
  let offset = isHovering ? 10 : 4;
  return {
    style: {
      left: progressPercentage + '%',
      marginLeft: -offset + 'px',
    },
  };
})`
  position: absolute;
  overflow: hidden;
  top: -1px;
  width: 0px;
  height: 0px;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  ${({ theme, isHovering }) => {
    let markerColor = theme.header;
    return css`
      border-bottom: 4px solid ${markerColor};
      ${() =>
        isHovering &&
        css`
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
          border-bottom: 18px solid ${markerColor};
        `}
    `;
  }}
`;
